// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".article .entry--image .multi-image{width:calc(50% - 2.5px)}.article .entry--image .multi-image:first-child{margin-right:2.5px}.article .entry--image .multi-image:last-child{margin-left:2.5px}.article .entry--image figure figcaption{margin-top:16px}.article .entry--image figure figcaption blockquote{quotes:none;border-left:3px solid #ddd;padding-left:10px;margin-left:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
